"use client";

import { useAuth } from "@/contexts/AuthContext";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import LoadingScreen from "@/components/LoadingScreen";

export default function Home() {
  const { user, loading } = useAuth();
  const router = useRouter();
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    if (!loading) {
      // Start exit animation immediately and navigate after it completes
      setShowLoading(false);
      const navTimer = setTimeout(() => {
        router.push(user ? "/dashboard" : "/login");
      }, 300); // Match the exit animation duration
      return () => clearTimeout(navTimer);
    }
  }, [user, loading, router]);

  return <LoadingScreen isVisible={showLoading} />;
}
